import React from "react";
import PropTypes from "prop-types";
import { Autocomplete, TextField } from "@mui/material";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { matchSorter } from "match-sorter";

function EnhancedAutocomplete(props) {
  const { label, options, selectedValue, selectedSetter, providedOnChange, isMultiSelect } = props;
  return (
    <Autocomplete
      multiple={isMultiSelect}
      disableCloseOnSelect
      limitTags={5}
      value={selectedValue}
      id="tags-standard"
      options={options}
      sx={{
        "width": 300,
        "bgcolor": "white",
        "borderRadius": "1rem",
        "height": 44,
        "mb": 2,
        "& .MuiInputBase-root": {
          height: 36,
          overflowY: "auto",
          overflowX: "hidden",
        },
        "& .Mui-focused": {
          color: "gray !important",
        },
      }}
      className="EnhancedAutocomplete border border-gray-300 mb-4 mr-4 h-11"
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label={label}
          InputProps={{ ...params.InputProps, disableUnderline: true }}
          sx={{
            mt: -1.5,
            mx: 1,
            width: 280,
          }}
        />
      )}
      renderOption={(props, option, { inputValue }) => {
        const matches = match(option, inputValue, { insideWords: true });
        const parts = parse(option, matches);
          return (
            <li {...props}>
              <div>
                {parts.map((part, index) => (
                  <span
                    key={index}
                    style={{
                      fontWeight: (isMultiSelect) ? ((part.highlight) ? 700 : 400) : ((option === inputValue) ? 700 : 400),
                      fontSize: 16,
                    }}
                  >
                    {part.text}
                  </span>
                ))}
              </div>
            </li>
          );
      }}
      filterOptions={(options, { inputValue }) =>
        matchSorter(options, inputValue)
      }
      onChange={(event, value) => {
        selectedSetter(value);
        providedOnChange();
      }}
    />
  );
}

EnhancedAutocomplete.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  selectedValue: PropTypes.arrayOf(PropTypes.string),
  selectedSetter: PropTypes.func,
  providedOnChange: PropTypes.func,
  isMultiSelect: PropTypes.bool
};

EnhancedAutocomplete.defaultProps = {
  label: null,
  options: [],
  selectedValue: [],
  selectedSetter: () => { },
  providedOnChange: () => { },
  isMultiSelect: true
};

export default EnhancedAutocomplete;
